import type { IntlShape } from 'react-intl';

const getBranchName = (
    branch: {
        id: string;
        name: string;
        isMainStock?: boolean;
    },
    intl: IntlShape
) => {
    return branch.isMainStock
        ? intl.formatMessage({ id: 'mainStock' })
        : branch.name;
};

export default getBranchName;
